
import TableList from "@components/templates/tablelist";
import { HttpBossProductList } from '@/service/inbound';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
            formData:{
                search:{
                    EQ_enable:1,
                }
            }
        };
    },
    methods: {
        ajaxRequest: HttpBossProductList,
    },
    computed: {
        SearchsData() {
            return [{
                label: "ERP SKU",
                tag: 'vInput',
                key: 'CN_erpSku',
                show: true,
            },
            {
                label: "名称",
                tag: 'vInput',
                key: 'EQ_name',
                show: true,
            }]
        },
        columns() {
            return [{
                title: "No.",
                type: 'index',
                width: 60,
            }, {
                title: "ERP SKU",
                key: 'erpSku'
            }, {
                title: "名称(中文)",
                key: 'name'
            }, {
                title: "名称(英文)",
                key: 'nameEn'
            },
            {
                title: "操作",
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', row)
                            }
                        }
                    }, "选择")
                }
            }]
        }
    }

};
